import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { getVariableCombinations, Region, VariableCombination } from '../api'
import { contentKeys } from '../queryKeys'

const useGetVariableCombinationQuery = ({
  personalizationId,
  region,
}: {
  personalizationId: string
  region: Region | undefined
}): UseQueryResult<VariableCombination, unknown> => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getContentQuery = useQuery(
    contentKeys.variableCombinations({
      personalizationId,
      region,
      accountId,
    }),
    () => getVariableCombinations({ personalizationId, accountId, region }),
    {
      meta: {
        errorMessage: 'Failed to fetch variable combinations',
      },
      enabled: !!region,
    }
  )

  return getContentQuery
}

export default useGetVariableCombinationQuery
